import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/store/auth';
import { getWechatAuthUrl } from '@/utils/api';
export default {
  name: 'WechatAuth',
  props: {
    // 授权成功后重定向的路径
    redirectPath: {
      type: String,
      default: '/'
    },
    // 授权提示文本
    authText: {
      type: String,
      default: '需要微信授权才能继续操作'
    }
  },
  setup() {
    const uRouter = useRouter();
    const authStore = useAuthStore();
    const isProcessing = ref(false);
    const loadingText = ref('授权中...');
    const error = ref(null);

    /**
     * 启动微信授权流程
     */
    const startWechatAuth = async () => {
      try {
        isProcessing.value = true;
        loadingText.value = '获取授权链接中...';
        error.value = null;

        // 获取当前页面URL作为回调地址
        const currentUrl = window.location.href;
        // 调用API获取微信授权URL
        const response = await getWechatAuthUrl(currentUrl);
        if (response.code !== 0) {
          throw new Error(response.message || '获取授权链接失败');
        }
        loadingText.value = '跳转授权页面中...';
        // 跳转到微信授权页面
        window.location.href = response.data.authUrl;
      } catch (err) {
        error.value = err.message || '授权失败，请稍后再试';
        isProcessing.value = false;
      }
    };

    /**
     * 检查URL中是否有授权code
     */
    const checkAuthCode = () => {
      //解析完整的url
      const url = new URL(window.location.href);
      const code = url.searchParams.get('code');
      //const state = url.searchParams.get('state');
      //获取哈西路由部
      const hash = url.hash;
      if (code) {
        window.history.replaceState({}, document.title, url.pathname + hash);
        isProcessing.value = true;
        loadingText.value = '处理授权中...';
        // 使用code获取用户信息
        authStore.getUserInfoByCode(code).then(() => {
          // 授权成功，跳转到指定页面
          const hashParams = new URLSearchParams(hash.split('?')[1] || '');
          const redirectUri = hashParams.get('redirect') || '/' + '/';
          uRouter.push({
            path: redirectUri
          });
        }).catch(err => {
          error.value = err.message || '授权处理失败';
          isProcessing.value = false;
        });
      }
    };

    // 组件挂载时检查是否有授权code
    checkAuthCode();
    return {
      isProcessing,
      loadingText,
      error,
      startWechatAuth
    };
  }
};